import { render, staticRenderFns } from "./MenuMiniGames.vue?vue&type=template&id=a4db89f4&scoped=true"
import script from "./MenuMiniGames.vue?vue&type=script&lang=js"
export * from "./MenuMiniGames.vue?vue&type=script&lang=js"
import style0 from "./MenuMiniGames.vue?vue&type=style&index=0&id=a4db89f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4db89f4",
  null
  
)

export default component.exports